/**
 * Duplication d'un élément de liste : la copie se place juste après l'original,
 * pour qu'elle apparaisse là où on l'attend plutôt qu'en fin de liste.
 *
 * Copie plate : les items de ces listes (slides, liens, étapes, badges, points
 * forts) n'ont que des valeurs simples et aucun identifiant à réattribuer.
 *
 * @returns {{list: object[], insertedIndex: number}} `insertedIndex` vaut -1
 *   quand l'index source est hors bornes (liste renvoyée inchangée).
 */
export function duplicateAtIndex(list, index) {
  const next = [...list];
  if (index < 0 || index >= next.length) return { list: next, insertedIndex: -1 };

  const insertedIndex = index + 1;
  next.splice(insertedIndex, 0, { ...list[index] });
  return { list: next, insertedIndex };
}

/**
 * Réordonnancement d'une liste par glisser-déposer : l'élément `fromIndex` va
 * se placer *avant* la position `insertBeforeIndex` de la liste d'origine
 * (0 = tout au début, length = tout à la fin).
 */
export function moveToInsertIndex(list, fromIndex, insertBeforeIndex) {
  const next = [...list];
  if (fromIndex < 0 || fromIndex >= next.length) return next;

  next.splice(fromIndex, 1);
  let idx = insertBeforeIndex;
  // Retirer l'élément décale d'un cran tout ce qui le suivait.
  if (fromIndex < insertBeforeIndex) idx -= 1;
  idx = Math.max(0, Math.min(idx, next.length));
  next.splice(idx, 0, list[fromIndex]);
  return next;
}
